import visitorsReducer from "./reducers";

export default visitorsReducer